import MultiCurrencyField from './MultiCurrencyField';

export default MultiCurrencyField;
